import React from 'react'
import styled from 'styled-components'

const FlipCard = styled.a`
    margin: 10px;
    background-color: transparent;
    width: 350px;
    height: 350px;
    border: 1px solid #f1f1f1;
    perspective: 1000px;
    &:hover > .inner{
        transform: rotateY(180deg);
    }
    @media ( max-width: 400px ) { 
        width: 250px;
        height: 250px;
        
    }
`

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(1,1fr);
    place-items: center;
    box-shadow: 1px 1px 4px rgba(0,0,0,0.3);
    margin: 10px;
    padding: 10px;
    text-transform: uppercase;


`

const FlipCardInner = styled.div`
    position: relative;
    width: 100%; height: 100%;
    text-align: center;
    transition: transform 0.8s;
    transform-style: preserve-3d;

    
    .front,.back{
        position: absolute;
        width: 100%; height: 100%;
        -webkit-backface-visibility: hidden;
        backface-visibility: hidden;
    }
    .front{
        background-color: #345;
        img{
            object-fit: fill;
            z-index: 3;
            width: 100%;
            height: 100%;
        }
    }
    .back {
        background-color: #eee;
        color: black;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        transform:rotateY(180deg)
    } 



`



const ImageCard = ({title , src , description , collection }) => {
  return (
    <Wrapper>
    <h2>{title}</h2>
    <FlipCard href={src}>
        <FlipCardInner className="inner">
            <div className="front">
                <img src={src} alt={title} />
            </div>
            <div className="back">
                <h4>{title}</h4>
                <h5>{collection}</h5>
                <p>{description}</p>
            </div>
        </FlipCardInner>
    </FlipCard>
    </Wrapper>
  )
}

export default ImageCard